// ----------------- AUTHORISE NET PAYMENT CREDENTIALS --------------------

export const GET_AUTHORISE_NET_PAYMENT_CREDENTIALS =
  "GET_AUTHORISE_NET_PAYMENT_CREDENTIALS";
export const RESET_AUTHORIZE_NET_CREDENTIALS =
  "RESET_AUTHORIZE_NET_CREDENTIALS";
